import { appRoutes } from '../routes/Routes'
import userImg from '../../../src/img/icons/user.svg'

export const menuItems: IMenuItems[] = [
	{
		faIcon: 'home' as any,
		route: appRoutes.homePage,
		text: 'Home',
	}, 
	{
		faIcon: 'comments' as any,
		route: appRoutes.supportPage,
		text: 'CustomerSupport',
	},
	{
		imgPath: userImg,
		route: appRoutes.userPage,
		text: 'MyAccount',
	},
	{
		faIcon: 'sign-out-alt' as any,
		route: appRoutes.logout,
		text: 'SignOut',
	},
]

export interface IMenuItems {
	faIcon?: any 
	imgPath?: string
	route: string
	text: string
}
